import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { hasError } from './utils';

import {
  TextField as DefaultTextFieldComponent,
  TextFieldProps as TextFieldComponentProps,
} from '../components/TextField';

const renderDefaultTextField = (props: TextFieldWrapperProps) => {
  const { name, type, fieldRenderProps, helperText: initialHelperText, ...restProps } = props;

  const {
    input: { value, onChange, onBlur },
    meta,
  } = fieldRenderProps;
  const { error, submitError } = meta;

  const isError = hasError(meta);
  const errorText = error || submitError;
  const helperText = isError ? errorText : initialHelperText;

  return (
    <DefaultTextFieldComponent
      name={name}
      error={isError}
      helperText={helperText}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      type={type}
      {...restProps}
    />
  );
};

export type TextFieldProps = TextFieldComponentProps & {
  name: string;
  fieldProps?: Partial<Parameters<typeof Field>[0]>;
  renderTextField?: (props: TextFieldWrapperProps) => React.ReactNode;
};

export type TextFieldWrapperProps = Omit<TextFieldProps, 'fieldProps'> & {
  fieldRenderProps: FieldRenderProps<any>;
};

export const TextField: React.FC<TextFieldProps> = (props) => {
  const {
    name,
    type,
    fieldProps,
    renderTextField = renderDefaultTextField,
    disabled,
    ...restProps
  } = props;
  const { isEditable } = useCanEditFormFieldsContext();
  const isDisabled = disabled || !isEditable;

  return (
    <Field name={name} type={type} {...fieldProps}>
      {(fieldRenderProps) => {
        return renderTextField({
          name,
          type,
          fieldRenderProps,
          disabled: isDisabled,
          ...restProps,
        });
      }}
    </Field>
  );
};
